import React from 'react'
import styled from 'styled-components'

export default function RadioGroup({ name, values, data, onClick }) {
  const options = values
    .filter(Boolean)
    .sort((a, b) => (a > b ? 1 : b > a ? -1 : 0))
    .map((item, i) => (
      <div key={i}>
        <input
          id={item.value}
          value={item.value}
          name={name}
          onChange={onClick}
          type="radio"
          checked={data[name] === item.value ? true : false}
        />
        <label htmlFor={item.value} value={item.value}>
          {item.label}
        </label>
      </div>
    ))

  return (
    <Wrapper>
      <Fieldset>
        <legend>
          {name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str) {
            return str.toUpperCase()
          })}
        </legend>
        <input
          id={`All ${name}`}
          value=""
          name={name}
          onChange={onClick}
          type="radio"
          checked={data[name] === '' || data[name] === undefined ? true : false}
        />
        <label htmlFor={`All ${name}`} value="">
          All
        </label>
        {options}
      </Fieldset>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 0 5px;
`

const Fieldset = styled.fieldset`
  padding: 5px;
  color: black;
  margin-bottom: 5px !important;
`
